<template>
  <div>
    <label class="text-bold mb-0">
      {{ $t('word.choices') }}
      <span class="badge badge-secondary badge-pill">
        {{ optionObjects.length }}
      </span>
    </label>
    <v-draggable v-model="optionObjects">
      <div v-for="(option, index) in optionObjects" :key="index">
        <div class="d-flex align-items-center m-1">
          <i class="fa fa-grip-lines grabbable mr-2"></i>
          <div class="w-100">
            <v-text-input
              :id="`item-config-choice-option-${index + 1}`"
              v-model="option.value"
              placeholder="sentence.write_option"
              :required="true"
            />
          </div>
          <i
            class="fa fa-minus-circle text-danger clickable ml-2"
            @click="optionObjects.splice(index, 1);"
          ></i>
        </div>
      </div>
    </v-draggable>
    <div class="d-flex justify-content-center mt-2 mb-2">
      <v-button
        text="phrase.add_option"
        id="item-config-choice-add-option"
        :disabled="optionObjects.length >= MAX_OPTIONS"
        icon="plus-circle"
        style-type="secondary"
        size="xs"
        @click="optionObjects.push({value: ''})"
      />
    </div>

    <div class="mb-2">
      <v-radio-buttons
        id="item-config-choice-direction"
        label="word.direction"
        :choices="DIRECTION_CHOICES"
        v-model="formData.config.direction"
        :required="true"
      />
    </div>

    <div>
      <strong>{{ $t('word.extra') }}</strong>
      <v-check-box
        id="item-config-choice-allow-other"
        label="sentence.add_other_namely"
        v-model="formData.config.allow_other"
      />

      <v-check-box
        id="item-config-choice-random-order"
        label="sentence.randomize_options"
        v-model="formData.config.random"
      />

      <div v-if="isMultiChoice(renderType)">
        <v-check-box
          id="item-config-choice-multiple"
          label="sentence.add_exclusive_response"
          v-model="exclusiveResponse"
        />
        <div v-if="exclusiveResponse" class="mb-3">
          <select
            class="form-control"
            id="item-config-choice-exclusive-response"
            v-model="formData.config.exclusive_response"
          >
            <option
              v-for="option in exclusiveResponseOptions"
              :key="option[0]"
              :value="option[0]"
            >
              "{{ $t(option[1]) }}"
            </option>
          </select>
        </div>
      </div>

      <div class="row" v-if="isMultiChoice(renderType)">
        <div class="col-12">
          <strong>{{ $t('sentence.max_min_options') }}</strong>
        </div>
        <div class="col-md-6">
          <v-text-input
            id="item-config-min"
            type="number"
            v-model="formData.config.min_options"
            placeholder="phrase.min_options"
          />
        </div>
        <div class="col-md-6">
          <v-text-input
            id="item-config-max"
            type="number"
            v-model="formData.config.max_options"
            placeholder="phrase.max_options"
          />
        </div>
      </div>
    </div>

    <div class="mt-2" v-if="errors && errors.config && errors.config.length > 0">
      <v-form-errors
        :errors="errors.config"
      />
    </div>
  </div>
</template>

<script>
import TextInput from '@/common/components/inputs/TextInput.vue';
import draggable from 'vuedraggable';
import Button from '@/common/components/Button.vue';
import FormErrors from '@/common/components/FormErrors.vue';
import CheckBox from '@/common/components/inputs/CheckBox.vue';
import RadioButtons from '@/common/components/inputs/RadioButtons.vue';
import {
  EXCLUSIVE_RESPONSE_OPTIONS,
  isMultiChoice,
} from '@/common/services/items';
import { DIRECTION_CHOICES } from '@/organisation/constants';

export default {
  name: 'ItemConfigChoice',
  components: {
    'v-button': Button,
    'v-check-box': CheckBox,
    'v-draggable': draggable,
    'v-form-errors': FormErrors,
    'v-radio-buttons': RadioButtons,
    'v-text-input': TextInput,
  },
  props: {
    formData: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      required: false,
    },
    renderType: {
      type: String,
      required: true,
    },
  },
  computed: {
    exclusiveResponseOptions() {
      return Object.entries(EXCLUSIVE_RESPONSE_OPTIONS);
    },
  },
  watch: {
    exclusiveResponse(value) {
      if (!value) {
        this.formData.config.exclusive_response = '';
      }
    },
    optionObjects: {
      handler() {
        this.formData.options = this.optionObjects.filter((option) => option.value !== '');
      },
      deep: true,
    },
  },
  methods: {
    isMultiChoice,
  },
  data() {
    return {
      EXCLUSIVE_RESPONSE_OPTIONS,
      DIRECTION_CHOICES,
      MAX_OPTIONS: 10,
      exclusiveResponse: false,
      optionObjects: [
        { value: '' },
      ],
    };
  },
  created() {
    if (this.formData.options.length > 0) {
      this.optionObjects = this.formData.options;
    }
    if (this.formData.config.exclusive_response) {
      this.exclusiveResponse = true;
    }
  },
};
</script>
